import { component } from 'picoapp';
import Drawer from 'utils/drawer';

export default component(async (node) => {
  const openFilterMenu = document.querySelector('[open-mobile-filter]');
  const closeButtons = node.querySelectorAll('[data-close]');
  const drawer = Drawer(node);

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      drawer.close();
    });
  });

  openFilterMenu.addEventListener('click', () => {
    drawer.open();
  });

  drawer.on('open', async () => {
    const disableScroll = (await import(
      /* webpackChunkName: "scroll-lock" */
      'modules/scroll-lock'
    )).default.disablePageScroll;
    disableScroll(node);
  });

  drawer.on('closed', async () => {
    const enableScroll = (await import(
      /* webpackChunkName: "scroll-lock" */
      'modules/scroll-lock'
    )).default;

    enableScroll.clearQueueScrollLocks();
    enableScroll.enablePageScroll(node);
  });
});
